const decodeReversed = (value) => value.split('').reverse().join('');

const RETIRED_CDN_HOST = decodeReversed('ten.tnorfduolc.ccbm25oc7icyd');
const RETIRED_S3_HOST = decodeReversed(
  'moc.swanozama.1-tsew-su.3s.3v-noitcudorp-oiirof'
);
const GCS_PATH_HOST = decodeReversed('moc.sipaelgoog.egarots');
const GCS_VIRTUAL_HOST = decodeReversed(
  'moc.sipaelgoog.egarots.3v-pcg-noitcudorp-oiirof'
);
const GCS_BUCKET = decodeReversed('3v-pcg-noitcudorp-oiirof');
const SUPPORTED_NAMESPACES = new Set(['store', 'public', 'uploads', 'static']);
const MAX_NESTED_URL_DEPTH = 10;

export const CANONICAL_MEDIA_ORIGIN = (
  process.env.RAZZLE_CONTENT_CDN || 'https://img.foriio.com/images'
).replace(/\/+$/, '');

export const DEFAULT_AVATAR_URL = `${CANONICAL_MEDIA_ORIGIN}/static/images/default_avatar.jpg`;
export const TWITTER_ICON_URL =
  'https://img.foriio.com/public/ginrnzMkYyBI_1669385152-';

export const buildCanonicalMediaUrl = (namespace, key) => {
  if (
    !SUPPORTED_NAMESPACES.has(namespace) ||
    typeof key !== 'string' ||
    key.length === 0
  ) {
    return null;
  }
  return `${CANONICAL_MEDIA_ORIGIN}/${namespace}/${key}`;
};

const mediaPathFor = (url) => {
  if (url.protocol !== 'https:' || url.port) return null;

  let path = url.pathname;
  if (url.hostname === GCS_PATH_HOST) {
    const bucketPrefix = `/${GCS_BUCKET}/`;
    if (!path.startsWith(bucketPrefix)) return null;
    path = path.slice(bucketPrefix.length - 1);
  } else if (
    url.hostname !== GCS_VIRTUAL_HOST &&
    url.hostname !== RETIRED_CDN_HOST &&
    url.hostname !== RETIRED_S3_HOST
  ) {
    return null;
  }

  const match = path.match(/^\/([^/]+)\/(.+)$/);
  if (!match || !SUPPORTED_NAMESPACES.has(match[1])) return null;
  return { namespace: match[1], key: match[2] };
};

const normalizeMediaUrlAtDepth = (value, depth) => {
  if (typeof value !== 'string' || depth > MAX_NESTED_URL_DEPTH) {
    return value;
  }

  let url;
  try {
    url = new URL(value);
  } catch (_error) {
    return value;
  }

  let queryChanged = false;
  const normalizedSearch = new URLSearchParams();
  for (const [key, queryValue] of url.searchParams.entries()) {
    const normalizedValue = normalizeMediaUrlAtDepth(queryValue, depth + 1);
    queryChanged = queryChanged || normalizedValue !== queryValue;
    normalizedSearch.append(key, normalizedValue);
  }

  const mediaPath = mediaPathFor(url);
  if (mediaPath) {
    const canonicalUrl = buildCanonicalMediaUrl(
      mediaPath.namespace,
      mediaPath.key
    );
    const search = queryChanged
      ? normalizedSearch.toString()
      : url.search.slice(1);
    return `${canonicalUrl}${search ? `?${search}` : ''}${url.hash}`;
  }

  if (!queryChanged) return value;
  url.search = normalizedSearch.toString();
  return url.toString();
};

export const normalizeMediaUrl = (value) => normalizeMediaUrlAtDepth(value, 0);

export const normalizeMediaPayload = (value) => {
  if (typeof value === 'string') return normalizeMediaUrl(value);
  if (Array.isArray(value)) return value.map(normalizeMediaPayload);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, child]) => [
        key,
        normalizeMediaPayload(child),
      ])
    );
  }
  return value;
};
